<template>
  <a-modal
    :title="title"
    :width="1200"
    :visible="visible"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="this.$store.getters.language['common.closeButton']">

    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">

          <a-col :span="6">
            <a-form-item :label="language['user.column.userAccount']">
              <a-input :placeholder="language['warning.userAccountRequired']" v-model="queryParam.username"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item :label="language['user.column.sex']">
              <a-select v-model="queryParam.sex" :placeholder="language['warning.genderRequired']">
                <a-select-option value="">{{ language['warning.genderRequired'] }}</a-select-option>
                <a-select-option value="1">{{ language['common.sex.man'] }}</a-select-option>
                <a-select-option value="2">{{ language['common.sex.woman'] }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <template v-if="toggleSearchStatus">
            <a-col :span="6">
              <a-form-item :label="language['system.user.name']">
                <a-input :placeholder="language['warning.userNamerequired']" v-model="queryParam.realname"></a-input>
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item :label="language['user.column.cellphoneNumber']">
                <a-input :placeholder="language['common.pleaseInput']+language['user.column.cellphoneNumber']" v-model="queryParam.phone"></a-input>
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item :label="language['column.status']">
                <a-select v-model="queryParam.status" :placeholder="language['common.pleaseInput']+language['column.status']">
                  <a-select-option value="">{{language['common.pleaseInput']+language['column.status']}}</a-select-option>
                  <a-select-option value="1">{{ language['downBoxValue.normal'] }}</a-select-option>
                  <a-select-option value="2">{{ language['common.thawButton'] }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>

          <a-col :span="6" >
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchByquery" icon="search">{{ language['common.searchButton'] }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ language['common.resetButton'] }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton'] : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
 <!--    update-begin author:kangxiaolin   date:20190921   for:系统发送通知 用户多选失败 #513  -->
    <a-table
      ref="table"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,onSelect:onSelect,onSelectAll:onSelectAll}"
      @change="handleTableChange"
    >
      <template slot="sex" slot-scope="text">
        <span v-if="text == 1">{{language["common.sex.man"]}}</span>
        <span v-else-if="text == 2">{{language["common.sex.woman"]}}</span>
        <span v-else>text</span>
      </template>
      <template slot="userStatus" slot-scope="text">
        <span v-if="text == 1">{{language['downBoxValue.normal']}}</span>
        <span v-else-if="text == 'APPLICATION'">{{language['downBoxValue.freeze']}}</span>
        <!--<span v-else>text</span>-->
      </template>
<!--     update-end   author:kangxiaolin  date:20190921     for:系统发送通知 用户多选失败 #513 -->
    </a-table>
  </a-modal>
</template>

<script>
  import { filterObj } from '@/utils/util';

  import { getUserList } from '@/api/api'

  export default {
    name: "SelectUserListModal",
    components: {
    },
    data () {
      return {
        applicationData:{
          applicationBy:'',
          selectedApplicationId:''
        },
        title:this.$store.getters.language['user'],
        queryParam: {},
        columns: [{
          title: this.$store.getters.language['user.column.userAccount'],
          align:"center",
          dataIndex: 'username',
          fixed:'left',
          width:200
        },{
          title: this.$store.getters.language['system.user.name'],
          align:"center",
          dataIndex: 'realname',
        },{
          title: this.$store.getters.language['user.column.sex'],
          align:"center",
          dataIndex: 'sex',
          scopedSlots: {customRender: 'sex'},
          /*customRender:function (text) {
            if(text==1){
              return this.$store.getters.language["common.sex.man"];
            }else if(text==2){
              return this.$store.getters.language["common.sex.woman"];
            }else{
              return text;
            }
          }*/
        },{
          title: this.$store.getters.language['user.column.cellphoneNumber'],
          align:"center",
          dataIndex: 'phone'
        },{
          title: this.$store.getters.language['column.mailbox'],
          align:"center",
          dataIndex: 'email'
        },{
          title: this.$store.getters.language['column.userStatus'],
          align:"center",
          dataIndex: 'status',
          scopedSlots: {customRender: 'userStatus'},
          /*customRender:function (text) {
            if(text==1){
              return this.$store.getters.language["downBoxValue.normal"];
            }else if(text==2){
              return this.$store.getters.language["downBoxValue.freeze"];
            }else{
              return text;
            }
          }*/
        }],
        dataSource:[],
        ipagination:{
          current: 1,
          pageSize: 5,
          pageSizeOptions: ['5', '10', '20'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " "+this.$store.getters.language['common.total'] + total + this.$store.getters.language["common.strip"]
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        isorter:{
          column: 'createTime',
          order: 'desc',
        },
        selectedRowKeys: [],
        selectionRows: [],
        visible:false,
        toggleSearchStatus:false,
      }
    },
    created() {

    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      add (selectUser,userIds) {
        this.visible = true;
        this.edit(selectUser,userIds);
      },
      edit(selectUser,userIds){
        //控制台报错
        if(userIds&&userIds.length>0){
          this.selectedRowKeys = userIds.split(',');
        }else{
          this.selectedRowKeys = []
        }
        if(!selectUser){
          this.selectionRows=[]
        }else{
          var that=this;
          that.selectionRows=[];
          selectUser.forEach(function(record,index){
            console.log(record)
            that.selectionRows.push({id: record.key,realname:record.label})
          })
          // this.selectionRows = selectUser;
        }
        this.loadData();
      },
      loadData (arg){
        if(arg===1){
          this.ipagination.current = 1;
        }
        let params = this.getQueryParams();//查询条件
        getUserList(params).then((res)=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      getQueryParams(){
        let param = Object.assign({}, this.queryParam,this.isorter);
        param.field = this.getQueryField();
        //--update-begin----author:scott---date:20190818------for:新建公告时指定特定用户翻页错误SelectUserListModal #379----
        // param.current = this.ipagination.current;
        // param.pageSize = this.ipagination.pageSize;
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        param.applicationBy = this.applicationData.applicationBy;
        param.selectedApplicationId = this.applicationData.selectedApplicationId;
        //--update-end----author:scott---date:20190818------for:新建公告时指定特定用户翻页错误SelectUserListModal #379---
        return filterObj(param);
      },
      getQueryField(){
        let str = "id,";
        for(let a = 0;a<this.columns.length;a++){
          str+=","+this.columns[a].dataIndex;
        }
        return str;
      },
      //--update-begin----author:kangxiaolin---date:20190921------for:系统发送通知 用户多选失败 #513----
      onSelectChange (selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys;
      },
      onSelect(record, selected){
        if(selected == true ){
          this.selectionRows.push(record);
        }else {
          this.selectionRows.forEach(function(item,index,arr){
            if(item.id == record.id) {
              arr.splice(index, 1);
            }
          })
        }
        //--update-end----author:kangxiaolin---date:20190921------for:系统发送通知 用户多选失败 #513----
      },
      onSelectAll(selected, selectedRows, changeRows){
        // this.selectionRows = selectedRows;
        if(selected == true ){
          selectedRows.forEach(record=>{
            let boo = false;
            for(var i=0;i<this.selectionRows.length;i++){
              let item = this.selectionRows[i];
              if(item.id == record.id) {
                boo = true
                break
              }
            }
            if(!boo){
              this.selectionRows.push(record);
            }
          })
        }else{
          changeRows.forEach(record=>{
            for(var i=0;i<this.selectionRows.length;i++){
              let item = this.selectionRows[i];
              if(item.id == record.id) {
                this.selectionRows.splice(i,1);
                break
              }
            }
          })
        }
      },
      searchReset(){
        let that = this;
        Object.keys(that.queryParam).forEach(function(key){
          that.queryParam[key] = '';
        });
        that.loadData(1);
      },
      handleTableChange(pagination, filters, sorter){
        //TODO 筛选
        if (Object.keys(sorter).length>0){
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend"==sorter.order?"asc":"desc"
        }
        this.ipagination = pagination;
        this.loadData();
      },
      handleCancel () {
        this.selectionRows = [];
        this.selectedRowKeys = [];
        this.queryParam={};
        this.visible = false;
      },
      handleOk () {
        this.$emit("choseUser",this.selectionRows);
        this.handleCancel();
      },
      searchByquery(){
        this.loadData(1);
      },
      handleToggleSearch(){
        this.toggleSearchStatus = !this.toggleSearchStatus;
      },
    }
  }
</script>
<style scoped>
  .ant-card-body .table-operator{
    margin-bottom: 18px;
  }

  .ant-table-tbody .ant-table-row td{
    padding-top:15px;
    padding-bottom:15px;
  }
  .anty-row-operator button{margin: 0 5px}
  .ant-btn-danger{background-color: #ffffff}

  .ant-modal-cust-warp{height: 100%}
  .ant-modal-cust-warp .ant-modal-body{height:calc(100% - 110px) !important;overflow-y: auto}
  .ant-modal-cust-warp .ant-modal-content{height:90% !important;overflow-y: hidden}

  .anty-img-wrap{height:25px;position: relative;}
  .anty-img-wrap > img{max-height:100%;}
</style>